// Utilidades de normalización de texto en español.
// Conservamos las tildes y la Ñ para mostrar, pero normalizamos para comparar.

const COMBINING_TILDE = '̃';   // ~ combinante (forma la ñ sobre la n)
const COMBINING_MARKS = /[̀-ͯ]/g;

/**
 * Normaliza una palabra para búsqueda en diccionario:
 * minúsculas, sin diacríticos EXCEPTO la ñ (que es una letra propia).
 * "CREACIÓN" -> "creacion", "NIÑO" -> "niño"
 */
export function normalizeForLookup(text) {
  if (!text) return '';
  const decomposed = text.normalize('NFD');
  // Reconstruimos la ñ (n + tilde combinante) antes de eliminar el resto de marcas.
  const preserved = decomposed.replace(new RegExp('n' + COMBINING_TILDE, 'gi'), (m) =>
    m[0] === 'N' ? 'Ñ' : 'ñ'
  );
  return preserved.replace(COMBINING_MARKS, '').toLowerCase();
}

/** Normaliza conservando tildes (solo minúsculas y trim). Para mostrar/comparar visualmente. */
export function toDisplayLower(text) {
  return (text || '').toLowerCase().trim();
}

/** Devuelve un array de "letras" Unicode (respeta caracteres compuestos simples). */
export function toLetters(text) {
  return Array.from(text || '');
}

/** Comprueba que la cadena solo contiene letras válidas del español. */
export function isValidSpanishWord(text) {
  return /^[a-záéíóúüñ]+$/i.test(text || '');
}

/** Cuenta letras reales (Unicode) de una palabra. */
export function letterCount(text) {
  return toLetters(text).length;
}
